<script setup>
import { createDescriptionMarkup } from "@/api/httpApi";

const props = defineProps(["resource"]);
</script>
<template>
  <div class="bg-light p-4 shadow-sm mt-5">
    <h2 class="h3 mb-3">Servizio</h2>
    <div class="bg-white p-4 mt-4">
      <h3 class="h4 mb-3" style="flex: 1">
        {{ props.resource?.name || "" }}
      </h3>
      <div class="border-top mb-2" style="height: 0.5rem">&nbsp;</div>
      <small class="fw-normal">Descrizione</small>
      <p
        class="fw-bold mb-3"
        v-html="createDescriptionMarkup(props.resource?.description)"
      ></p>
      <div class="border-top mb-2" style="height: 0.5rem">&nbsp;</div>
      <small class="fw-normal">Sede</small>
      <p class="fw-bold mb-3">{{ props.resource?.place || "" }}</p>
      <div class="border-top mb-2" style="height: 0.5rem">&nbsp;</div>
    </div>
  </div>
</template>
